import React, { memo } from 'react';
import Avatar, { Skeleton } from '@atlaskit/avatar';
import { MediaClientProvider } from '@atlaskit/media-client-react';
import { MediaImage } from '@atlaskit/media-image';
var IMAGE_SIZE = {
  width: 24,
  height: 24
};

// We want to reuse mediaClientConfigs across all CmdbIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
var mediaClientConfigs = new Map();
var getMediaClientConfig = function getMediaClientConfig(_ref) {
  var mediaJwtToken = _ref.mediaJwtToken,
    clientId = _ref.clientId,
    mediaBaseUrl = _ref.mediaBaseUrl;
  var key = "".concat(mediaJwtToken, ":").concat(clientId, ":").concat(mediaBaseUrl);
  var existingMediaClientConfig = mediaClientConfigs.get(key);
  if (existingMediaClientConfig) {
    return existingMediaClientConfig;
  }
  var mediaClientConfig = {
    authProvider: function authProvider() {
      return Promise.resolve({
        clientId: clientId,
        token: mediaJwtToken,
        baseUrl: mediaBaseUrl
      });
    },
    useSha256ForUploads: true
  };
  mediaClientConfigs.set(key, mediaClientConfig);
  return mediaClientConfig;
};
var hasAuth = function hasAuth(_ref2) {
  var mediaBaseUrl = _ref2.mediaBaseUrl,
    mediaJwtToken = _ref2.mediaJwtToken,
    fileId = _ref2.fileId,
    clientId = _ref2.clientId;
  return Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
};
var DefaultIcon = function DefaultIcon() {
  return /*#__PURE__*/React.createElement(Avatar, {
    appearance: "square",
    size: "small"
  });
};
var CmdbIconInternal = function CmdbIconInternal(props) {
  if (!hasAuth(props)) {
    return /*#__PURE__*/React.createElement(DefaultIcon, null);
  }
  var fileIdentifier = {
    id: props.fileId,
    mediaItemType: 'file'
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MediaClientProvider, {
    clientConfig: getMediaClientConfig(props)
  }, /*#__PURE__*/React.createElement(MediaImage, {
    identifier: fileIdentifier,
    mediaClientConfig: getMediaClientConfig(props),
    apiConfig: IMAGE_SIZE
  }, function (_ref3) {
    var loading = _ref3.loading,
      error = _ref3.error,
      data = _ref3.data;
    if (loading) {
      return /*#__PURE__*/React.createElement(Skeleton, {
        appearance: "square",
        size: "small"
      });
    }
    if (error) {
      return /*#__PURE__*/React.createElement(DefaultIcon, null);
    }
    if (!data) {
      return /*#__PURE__*/React.createElement(DefaultIcon, null);
    }
    return /*#__PURE__*/React.createElement(Avatar, {
      src: data.src,
      appearance: "square",
      size: "small"
    });
  })));
};
export var CmdbIcon = /*#__PURE__*/memo(CmdbIconInternal);